module.exports = __webpack_public_path__ + "img/VENUET.e1b287db.png";